<template>
  <div class="p-5 pt-16 h-screen">
    <div>
      <img :src="nombreImagenLogoClub" height="75%" width="75%" alt="Logotipo Jockey Club" style="display: block; margin-left: auto; margin-right: auto;" />
      <form @submit.prevent="login" class="px-8 pt-6 content-start">
        <div class="mb-4">
          <input
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            v-model="nombreUsuario"
            type="text"
            placeholder="Email"
          />
        </div>
        <div class="mb-6">
          <input
            class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            v-model="contrasena"
            type="password"
            placeholder="Contraseña"
          />
        </div>
        <div class="flex items-center justify-between">
          <button class="bg-paleta-3 text-white font-bold py-2 px-4 rounded justify-left" :disabled="verificando">
            Ingresar
          </button>
          <router-link to="/olvideMiContrasena/olvideMiContrasena" class="underline">Olvidé mi contraseña</router-link>
        </div>
      </form>
      <div v-if="error" class="bg-red-700 text-white p-1 my-2">
        {{ error }}
      </div>
      <div class="flex items-center justify-between gap-10 px-8 mt-10 m-2">
        <div class="text-white">¿Todavía no tenes cuenta?</div>
        <router-link to="/registro" class="underline">Registrarme</router-link>
      </div>
      <div class="flex items-center justify-between gap-10 px-8 mt-10 m-2">
        <a href="https://jcvm.softrental.net:9011/api/Sistema/Old" target="_blank">Dispositivos antiguos: click aquí</a>
      </div>
      <img src="../../assets/images/logo_app.png" height="50%" width="50%" alt="Logotipo aplicación" style="display: block; margin-left: auto; margin-right: auto;" />
      <p class="text-center text-gray-500 text-xs mt-5">
        &copy;2020 ArTurf. Todos los derechos reservados
      </p>
    </div>
    <div
      v-if="verificando"
      class="fixed z-10 bg-black bg-opacity-50 flex justify-center  text-white"
      style="top: 0;
  left: 0;
  bottom: 0;
  right: 0;align-items: center;"
    >
      Verificando...
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "@/router";
import { mapState } from "vuex";
import sha1 from "js-sha1";
import usuariosService from "@/services/UsuariosService";
import ipService from "@/services/IpService";

export default {
  name: "Login",
  data: function() {
    return {
      nombreUsuario: "",
      contrasena: "",
      submitted: false,
      nombreImagenLogoClub: require("../../assets/images/" + process.env.VUE_APP_LOGO_INSTITUCION),
      error: null,
      verificando: false
    };
  },
  methods: {
    login() {
      this.submitted = true;
      const { nombreUsuario, contrasena } = this;
      if (nombreUsuario && contrasena) {
        this.verificando = true;
        ipService.obtenerIp(response => {
          if (response.status === 200) {
            const ip = response.data.ip;
            const apiToken = process.env.VUE_APP_API_TOKEN;
            const version = process.env.VUE_APP_VERSION;
            usuariosService.login(nombreUsuario, sha1(contrasena), ip, apiToken, version, response => {
              this.verificando = false;
              if (response.data.resultado === "OK") {
                this.$store.dispatch("loginExitoso", {
                  data: response.data
                });

                Vue.conectarSignalR();

                if (response.data.geoControl.accion != "HABILITADA" || response.data.datosPersonales.mensaje != "") {
                  router.push("/mensajes");
                } else {
                  router.push("/menu");
                }
              } else {
                this.error = response.data.mensaje;
              }
            });
          } else {
            this.verificando = false;
            this.error = "No se pudo detectar su IP";
          }
        });
      }
    }
  },
  computed: {
    ...mapState({
      usuario: state => state.sesion.usuario
    })
  }
};
</script>
